import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { Ubicacion } from '@shared/models';
import { UbicacionCamino } from '@shared/models/catalogo/Ubicacion.model';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_UBICACIONES = '/ubicacion';

@Injectable({
  providedIn: 'root',
})
export class UbicacionService {
  private readonly API_URL_UBICACIONES = API_URL + ENDPOINT_UBICACIONES;
  private http = inject(HttpClient);

  listarNivel1(): Observable<Ubicacion[]> {
    return this.http.get<ResponseWrapper<Ubicacion[]>>(`${this.API_URL_UBICACIONES}/paises`).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }

  listarNivel2(paisId: number): Observable<Ubicacion[]> {
    return this.http
      .get<ResponseWrapper<Ubicacion[]>>(`${this.API_URL_UBICACIONES}/departamentos/${paisId}`)
      .pipe(
        map((res) => {
          return res.data;
        }),
      );
  }

  listarNivel3(deptoId: number): Observable<Ubicacion[]> {
    return this.http
      .get<ResponseWrapper<Ubicacion[]>>(`${this.API_URL_UBICACIONES}/provincias/${deptoId}`)
      .pipe(
        map((res) => {
          return res.data;
        }),
      );
  }

  listarNivel4(provinciaId: number): Observable<Ubicacion[]> {
    return this.http
      .get<ResponseWrapper<Ubicacion[]>>(`${this.API_URL_UBICACIONES}/distritos/${provinciaId}`)
      .pipe(
        map((res) => {
          return res.data;
        }),
      );
  }

  obtenerNivelesByUbicacionId(ubicacionId: number): Observable<UbicacionCamino> {
    return this.http
      .get<ResponseWrapper<UbicacionCamino>>(`${this.API_URL_UBICACIONES}/niveles/${ubicacionId}`)
      .pipe(
        map((res) => {
          return res.data;
        }),
      );
  }
}
